<template>
  <div class="gov-course-detail">
    <!-- 顶部背景 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <div class="top-banner-center">
          <div class="wow animate__animated animate__zoomIn banner-btn" @click="onClickLookMore">
            服务咨询
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="top-btn">
        <div class="btn-com" :class="params.courseStatus === item.value ? 'btn-select' : 'btn-normal'
          " v-for="item in paramsTypeList" :key="item" @click="onClickType(item)">
          {{ item.title }}
        </div>
      </div>

      <div :class="dataList.length > 0 ? 'gov-course' : 'gov-course-loading'" v-loading="dataLoading">
        <div>
          <div class="wow animate__animated animate__fadeIn training-list-list">
            <el-row :gutter="45">
              <div v-for="(item, index) in dataList" :key="index">
                <el-col class="training-list-item-box">
                  <div class="training-list-img" :style="{
                    backgroundImage: `url(https://static.zhuzaocloud.com${item.logo})`,
                  }" @click="onClickDetail(item)"></div>
                  <div class="training-list-info-box">
                    <div class="training-course-name">{{ item.name }}</div>
                    <div class="course-info-body">
                      <div class="training-course-info">
                        <div>报名时间：</div>
                        <div>
                          {{
                            moment(item.liveBeginTime).format(
                              "YYYY年MM月DD日"
                            )
                          }} - {{
  moment(item.liveEndTime).format(
    "YYYY年MM月DD日"
  )
}}
                        </div>
                      </div>
                      <!-- <div class="training-course-info">
                        <div>培训时间：</div>
                        <div>
                          {{
                            moment(item.courseStartTime).format(
                              "YYYY年MM月DD日"
                            )
                          }} - {{
                            moment(item.courseEndTime).format(
                              "YYYY年MM月DD日"
                            )
                          }}
                        </div>
                      </div> -->
                      <div class="training-course-info">
                        <div>培训方式：</div>
                        <div>
                          {{ item.sellType == "COURSE" ? "线上" : "线下" }}
                        </div>
                      </div>
                      <div class="training-course-info">
                        <div>培训地点：</div>
                        <div>{{ item.address }}</div>
                      </div>
                      <div class="training-course-info">
                        <div>培训学时：</div>
                        <div>{{ item.period }}学时</div>
                      </div>
                      <div class="training-course-info">
                        <div>培训费用：</div>
                        <div>{{ item.currentprice }}</div>
                        <div>元/人</div>
                      </div>
                    </div>
                    <div class="training-course-bottom">
                      <div class="course-info-btn-box">
                        <el-popover placement="top" width="200" trigger="click" class="el-popover-box">
                          <wechart-qr-code ref="wechartQrCode"></wechart-qr-code>
                          <!-- status: '0'未开始，'1'进行中，'2'已结束 -->
                          <el-button slot="reference" type="primary" @click="resClickEvet(item.id, item.logo, index)"
                            :disabled="item.status == 1 ? false : true" :class="item.status == 1
                              ? 'el-button--primary'
                              : 'el-button--primary-disabled'
                              " style="width:150px">
                            <span v-if="item.status == 2">已结束</span>
                            <span v-else>立即报名</span>
                          </el-button>
                        </el-popover>
                      </div>
                      <div style="margin-left:20px">
                        (限报人数:{{ item.peopleNum }})
                      </div>
                    </div>
                  </div>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
      </div>
      <div style="text-align: center;padding: 80px 0;">
        <el-pagination @current-change="onChangeCurrent" :current-page="params.currentPage" :page-size="params.pageSize"
          background layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { queryTrain, getDictionaryItem } from "../../utils/interface"
import wechartQrCode from "./wechartQrCode"
export default {
  components: { wechartQrCode },
  data() {
    return {
      headerBgUrl: "",
      params: {
        currentPage: 1,
        pageSize: 4,
        courseStatus: "0", // '0'查全部，'2'正在报名，'3'报名结束
        // sellType: "COURSE",
        // lickCode: "",
      },
      total: 0,
      paramsTypeList: [
        { title: "全部", value: "0" },
        { title: "正在报名", value: "2" },
        { title: "报名结束", value: "3" },
      ],

      dataList: [],

      dataLoading: true,

      dialogVisible: false,
    }
  },
  created() {
    this.getOptionsData()
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataLoading = true
      queryTrain(this.params)
        .then((res) => {
          this.dataLoading = false
          this.total = res.total
          if (res.list) {
            this.dataList = res.list
            // this.showListType()
          } else {
            this.dataList = []
            // this.dataFirst = null
          }
        })
        .catch((err) => {
          this.dataLoading = false
        })
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "RCFW_BANNER",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value
        } else {
          this.headerBgUrl = ""
        }
      })
    },
    toViewVideo() { },
    onClickType(item) {
      this.params.currentPage = 1
      this.params.courseStatus = item.value
      this.getDataList()
    },
    onChangeCurrent(e) {
      this.params.currentPage = e
      this.getDataList()
    },
    onClickDetail() { },
    onClickLookMore() { },
    resClickEvet(id, logoUrl, index) {
      this.dialogVisible = true
      console.log("查看refs:", this.$refs)
      this.$refs.wechartQrCode[index].initData(id, logoUrl)
    },
  },
}
</script>
<style scoped lang="less">
@basic-colors: #009999;

.gov-course-detail {
  // background: rgb(245 245 245);
  background: #ffffff;
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .top-banner-box {
    // background-color: #f7f8fb;

    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-banner-center {
        width: 1300px;
        height: 500px;
        position: relative;
      }

      .banner-btn {
        width: 130px;
        margin-left: 30px;
        // background-color: white;
        color: transparent;
        letter-spacing: 2px;
        text-align: center;
        padding: 12px 0;
        border-radius: 7px;
        cursor: pointer;
        user-select: none;
        position: absolute;
        bottom: 77px;
        transition: all 0.2s;
      }
    }
  }

  .container {
    width: 1300px;
    margin: 0 auto;

    .breadcrumb {
      width: 1300px;
      margin: 0 auto;
      background: #ffffff;
      margin-top: 10px;
      border-bottom: 1px solid #ccc;
    }

    .top-btn {
      display: flex;
      -webkit-box-pack: center;
      justify-content: center;

      .btn-com {
        width: 200px !important;
        height: 50px !important;
        border-radius: 31px !important;
        font-size: 20px !important;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: center;
        cursor: pointer;
        user-select: none;
        margin: 24px;
        transition: all 0.2s;
        box-sizing: border-box;
      }

      .btn-normal {
        border: 1px solid #2d50a1;
        color: #000;
        background-color: #ffffff;
        width: 210px;
        height: 29px;
      }

      .btn-select {
        color: white;
        background-color: #2d50a1;
        width: 210px;
        height: 29px;
      }
    }

    .gov-course {
      .training-title {
        font-size: 26px;
        font-weight: bold;
        color: #333333;
      }

      .training-top-box {
        display: flex;
        padding: 0 80px;
        margin: 30px 0 0 0;
        color: white;
      }

      .training-top-left {
        width: 400px !important;
        height: 250px !important;
      }

      .training-top-right {
        width: 640px !important;
        height: 200px !important;
        margin-top: 25px !important;
      }

      .training-bottom-title {
        font-size: 26px;
        font-weight: bold;
        max-width: 90%;
      }

      .training-bottom-status {
        font-size: 14px;
        height: 21px;
        line-height: 21px;
        padding: 1px 2px;
        background: #e63e1d;
        border-radius: 8px;
        border: 1px solid #ffffff;
        margin: auto 15px;
      }

      .training-bottom-des {
        margin-top: 12px;
        font-size: 14px;
        line-height: 24px;
        height: 48px;
      }

      .training-bottom-date {
        margin-top: 15px;
        font-size: 16px;
        line-height: 24px;
      }

      .training-list-list {
        .training-list-item-box {
          display: flex;
          justify-content: space-around;
          width: 96.66%;
          -webkit-box-align: end;
          align-items: flex-end;
          margin-bottom: 30px;

          .training-list-img {
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 560px;
            height: 315px;
            margin-bottom: 0px !important;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            transition: all 0.3s;
            border-radius: 16px;
          }

          .training-list-info-box {
            width: 627px;
            height: 315px;

            .training-course-name {
              font-size: 20px;
              font-weight: 900;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 6px;
            }

            .course-info-body {
              margin-top: 45px;
              margin-left: 10px;
              font-weight: 500;

              .training-course-info {
                display: flex;
                height: 30px;
              }
            }

            .training-course-bottom {
              display: flex;
              align-items: flex-end;
              margin-top: 45px;
              margin-left: 11px;

              .course-info-btn-box {
                /deep/ .el-button--primary {
                  color: #fff;
                  background-color: #2d50a1;
                  border-color: #2d50a1;
                  border-radius: 8px;
                  font-size: 16px;
                  width: 150px;
                  font-weight: 700;
                  padding: 10px 15px;
                  letter-spacing: 2px;

                  &:hover {
                    color: #2d50a1;
                    background-color: #bbc5db;
                  }
                }

                .el-button--primary-disabled {
                  filter: grayscale(100%);
                }
              }
            }
          }
        }
      }
    }

    .gov-course-loading {
      height: 1380;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #2d50a1;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/trainingCourseList.vue